jQuery(document).ready(function($) {

// Navigation

	$('.popup_menu').click(function(event) {
		event.preventDefault();
		$('body').toggleClass('nav_opened');
	});

	// Mobile Subnav
	$('.subnav-toggle').click(function() {
		$('.widget_nav_menu').slideToggle();
		$(this).toggleClass('active');
	});

    // Analytics event tracking
    $('.menu-item-18336').click(function() {
        ga('send', 'event', 'New Guest Offer', 'Download', 'Subnavigation');
    });

});

(function($) {
    var $window = $(window),
        $html = $('body');

    function resize() {
        if ($window.width() < 480) {
            return $html.addClass('mobile');

        }

        $html.removeClass('mobile');
    }

    $window
        .resize(resize)
        .trigger('resize');
})(jQuery);

jQuery.noConflict();
(function($) {

/*******************************
// Accordion Navigation
*******************************/
function closeNav(){
    $('.goback').removeClass('on');
    var listitems = $('.navScreen_holder_inner > ul>li.menu-item');
    if(listitems.hasClass('collapse')) {
        setTimeout(function() {
            listitems.removeClass('collapse').css('z-index', '3');
            listitems.removeClass('expanded');
            $('.navScreen_holder_inner .social').fadeToggle();
        }, 400);
    }
    listitems.find('ul').removeClass('open');
}
$('.navScreen_holder_inner > ul > li.menu-item-has-children > a').click(function(event){
    $('.navScreen_holder_inner .social').fadeToggle();
    var mainitem = $(this).parent();
    var listitems = $('.navScreen_holder_inner > ul>li.menu-item').not(mainitem);
    event.preventDefault();
    $(mainitem).addClass('expanded');
    listitems.addClass('collapse').delay(100).css('z-index', '-99');
    if($(mainitem).find('ul').hasClass('open')) {
        closeNav();
    } else {
        setTimeout(function() {
            $(mainitem).find('ul').addClass('open');
        }, 400);
    }
        setTimeout(function() {
    $('.goback').delay(1000).addClass('on');
        }, 400);
});
$('.goback').click(function(event){ closeNav(); });


/*******************************
// mobile subnavigation
*******************************/
$('.opensub').click(function(event){
    $(this).toggleClass('open');
    $('#sidenav').slideToggle('fast');
    if($('#sidenav').hasClass('open')) {
        $('#sidenav').removeClass('open');
    } else {
        $('#sidenav').addClass('open');
    }
});

/*******************************
// LOCATIONS
*******************************/
var speed = 500,
  $container = $('#locations'),
  $posts = $container.find('.locationwrapper');
var $locgrid = $('#locations').imagesLoaded(function() {
  // init Masonry after all images have loaded
  $locgrid.masonry({
    itemSelector: '.locationwrapper:not(.invis)',
    columnWidth: '.location-sizer',
    gutter: '.gutter-sizer',
    isAnimated: true,
    percentPosition: true
  });
});
$('#locselectors li').click(function() {
  $('#locselectors li').removeClass('active');
  $(this).addClass('active');
  var filterClass = '.' + $(this).attr('id');
  if (filterClass === '.all') {
    // show all hidden boxes
    $posts.filter('.invis').toggleClass('invis').fadeIn(speed);
  } else {
    // hide visible boxes
    $posts.not(filterClass).not('.invis').toggleClass('invis').fadeOut(speed);
    // show hidden boxes
    $posts.filter(filterClass + '.invis').toggleClass('invis').fadeIn(speed);
  }
  setTimeout(function() {
    $locgrid.masonry('layout');
  }, 600);
});

// parse URL hashes
var hash = window.location.hash;
if (hash == ""){}
if (hash){
    // Checking radio buttons for locations based on hash passed from locations page links
    $(hash).prop('checked', true);
    $(hash).click();
}





// end it all

var $grid = $('.mason_gallery').imagesLoaded( function() {
  // init Masonry after all images have loaded
  $grid.masonry({
    itemSelector: '.column'
  });
});
})(jQuery);
